import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

interface GetDurationOrNullParams {
  startTime?: number;
  endTime?: number;
}
export const getDurationOrNull = ({ startTime, endTime }: GetDurationOrNullParams) => {
  if (!(endTime && startTime)) {
    return null;
  }

  const startTimeDate = dayjs(startTime);
  const endTimeDate = dayjs(endTime);
  const difference = endTimeDate.diff(startTimeDate).valueOf();

  return Number.isNaN(difference) ? null : difference;
};

export const formatDuration = (durationInSeconds: number) => {
  const truncatedDuration = Math.trunc(durationInSeconds);

  return truncatedDuration > 59
    ? dayjs.duration(truncatedDuration, 'seconds').format('m[m] s[s]')
    : `${truncatedDuration}s`;
};

export const getAmPm = (time: number): 'AM' | 'PM' => (dayjs(time).hour() < 12 ? 'AM' : 'PM');

export const toggleAmPm = (time: number): number =>
  dayjs(time).hour() < 12 ? dayjs(time).add(12, 'hour').valueOf() : dayjs(time).subtract(12, 'hour').valueOf();

export const getTimeRangeBasedOnRetention = (retentionDays: number) => {
  const now = dayjs();
  const earliestStartTime = now.subtract(retentionDays, 'days').valueOf();
  const latestEndTime = now.valueOf();
  return { earliestStartTime, latestEndTime };
};

interface ValidateFilterDateParams {
  date: number;
  retentionDays: number;
}

export const validateFilterDate = ({ date, retentionDays }: ValidateFilterDateParams) => {
  const dateObj = dayjs(date);
  if (!dateObj.isValid()) return { isValid: false, error: 'Invalid date format' };

  const now = dayjs();
  const earliestAllowed = now.subtract(retentionDays, 'days');

  if (dateObj.isBefore(earliestAllowed)) {
    return { isValid: false, error: `Date cannot be more than ${retentionDays} days ago` };
  }

  if (dateObj.isAfter(now)) {
    return { isValid: false, error: 'Date cannot be in the future' };
  }

  return { isValid: true };
};

interface ValidateFilterDateRangeParams {
  startDate: number;
  endDate: number;
}

export const validateFilterDateRange = ({ startDate, endDate }: ValidateFilterDateRangeParams) =>
  startDate && endDate && dayjs(startDate).isAfter(dayjs(endDate))
    ? { isValid: false, error: 'Start date cannot be after end date' }
    : { isValid: true };

export const isSameMinute = (time1: number | null, time2: number | null): boolean => {
  if (time1 === null && time2 === null) return true;
  return dayjs(time1).isSame(dayjs(time2), 'minute');
};
